'use strict';
var ProductDetailController = /** @class */ (function () {
    /*@ngInject*/
    function ProductDetailController($scope, $filter, $compile, $window, $sce, $state, $location, $rootScope, $timeout, UserService, CartService, ProductService, Auth, $stateParams, $anchorScroll, metaService, titleService, CommonDataService, googleAnalytic) {
        var _this = this;
        //$scope.active = true;
        // set the default amount of items being displayed
        this.selectedTab = 'supplement';
        this.showDisclaimer = false; // used for mobile disclaimer tooltip
        this.warningMessage = {
            heatSensitive: {
                icon: '../../assets/images/icons/thermo-icon.png',
                content: 'Overnight shipping is recommended. Not recommended for international shipping.'
            },
            tempHeatSensitive: {
                icon: '../../assets/images/icons/thermo-icon.png',
                content: 'Heat sensitive due to season. Overnight shipping is recommended.'
            },
            shortShelfLife: {
                icon: '../../assets/images/icons/icon_shelf-life.png',
                content: 'Item has a short shelf life of 6 months or less.'
            },
            prop65_CA: {
                icon: '../../assets/images/attention.png',
                content: 'This item can only be shipped to California.',
            },
            prop65_NonCA: {
                icon: '../../assets/images/attention.png',
                content: 'This item cannot be shipped to California.'
            }
        };
        this.inventories = {};
        this.products = {};
        this.itemDetail = {};
        this.getOtherIngredients = function (ingredient) {
            var otherIngredients = [];
            if (!!ingredient) {
                ingredient.forEach(function (arr) {
                    if (arr.isActive == false) {
                        otherIngredients.push(arr.supplierName);
                    }
                });
            }
            return otherIngredients.join(", ");
        };
        this.sortOption = null;
        this.sortListVisible = false;
        this.isSortPlaceholder = true;
        this.sortSelected = "";
        this.sortProperty = "";
        this.select = function (item) {
            this.isSortPlaceholder = false;
            this.sortSelected = item;
            this.sortListVisible = false;
            this.display = item;
        };
        this.isSelected = function (item) {
            return item[this.sortProperty] === this.sortSelected[this.sortProperty];
        };
        this.sortShow = function () {
            console.log('show');
            this.sortListVisible = true;
        };
        this.oldPurchaseQuantity = 1;
        this.showAddedToCartPopup = function () {
            var _this = this;
            this.displayPopup = true;
            this.$timeout(function () {
                _this.displayPopup = false;
            }, 4000);
        };
        this.clearQuantity = function () {
            this.purchaseNumber = '';
        };
        var self = this;
        this.addingToCart = false;
        this.cart = CartService;
        this.Auth = Auth;
        this.productService = ProductService;
        this.$timeout = $timeout;
        this.CommonDataService = CommonDataService;
        this.$rootScope = $rootScope;
        this.metaService = metaService;
        this.titleService = titleService;
        this.$filter = $filter;
        this.$state = $state;
        this.purchaseNumber = 1;
        this.insufficientQty = false;
        this.showBackInStockDate = false;
        this.GoogleAnalyticsService = googleAnalytic;
        this.accordianItem = {
            "suggested": false,
            "dietary": false,
            "warnings": false,
            "education": false,
            "productinfo": false
        };
        this.AllAlternateIds = new Array();
        this.CarouselIds = new Array();
        this.carouselcapacity = 4;
        /*Show more less functionality for 400 char*/
        this.showMoreDesc = true;
        this.limitCharto = 400;
        this.productDesc = '';
        var controller = this;
        $scope.$on('$destroy', function () {
            console.log("called");
            controller.titleService.setTitle(controller.previousTitle);
            controller.metaService.updateTag({ name: 'description', content: controller.previousDescription });
        });
        this.changeLimit = function () {
            if (self.products.description) {
                self.isDescriptionOverSize = self.products.description.length > _this.limitCharto;
                if (self.showMoreDesc) {
                    var descArr = self.products.description.substring(0, _this.limitCharto).split(" ");
                    var lastString = descArr.pop();
                    self.productDesc = descArr.join(" ") + " " + _this.stripHtmlTags(lastString.toString());
                }
                else {
                    self.productDesc = self.products.description;
                }
                self.showMoreDesc = self.showMoreDesc ? false : true;
            }
        };
        this.stripHtmlTags = function (htmlContent) {
            var spanEle = document.createElement('span');
            spanEle.innerHTML = htmlContent;
            return spanEle.textContent.toString().replace(/[<\/]*/g, '');
        };
        /*Show more less functionality for 400 char*/
        $scope.goToSimilarProducts = ProductService.gotoAlternateProduct;
        ProductService.gotoAlternateProduct = false;
        $scope.error = false;
        self.addToCart = function (itemCode, quantity, form) {
            var _this = this;
            if (!self.purchaseNumber) {
                return false;
            }
            if (form[itemCode].$valid) {
                this.addingToCart = true;
                this.cart.addItemQuantity(itemCode, quantity)
                    .then(function () {
                    _this.showAddedToCartPopup();
                })
                    .finally(function () {
                    _this.addingToCart = false;
                });
            }
        };
        this.$rootScope.$on("updateInventoryMessaging", function (event, insufficientItemFlag) {
            self.insufficientQty = insufficientItemFlag;
        });
        ProductService.getTaxonomies()
            .then(function (response) {
            _this.allcatList = response;
        });
        self.getTaxonomyId = function (taxonomyName, taxonomyType) {
            var taxonomyData = this.allcatList.filter(function (taxonomyList) {
                if (taxonomyType === taxonomyList.taxonomyType && taxonomyName === taxonomyList.displayName) {
                    return taxonomyList;
                }
            });
            if (taxonomyData != null)
                self.shopTaxonomy(taxonomyData);
        };
        self.setBrandData = function (brandId, brandName) {
            var brandData = [{ "taxonomyId": brandId, "displayName": brandName, "taxonomyType": "Brand" }];
            if (brandData != null)
                self.shopTaxonomy(brandData);
        };
        self.shopTaxonomy = function (taxonomyData) {
            var prefix = '';
            var res = taxonomyData[0];
            if (res.taxonomyType == 'Category')
                prefix = '-C';
            else if (res.taxonomyType == 'Subcategory')
                prefix = '-S';
            else if (res.taxonomyType == 'Condition')
                prefix = '-D';
            else if (res.taxonomyType == 'Attribute')
                prefix = '-A';
            else if (res.taxonomyType == 'Brand')
                prefix = '-B';
            var filterValue = self.urlStrip(res.displayName) + prefix + res.taxonomyId;
            $state.transitionTo('searchResults', { searchFilter: filterValue });
        };
        self.urlStrip = function (str) {
            if (str) {
                return str.replace(/[^\w\d\s]*/g, '').replace(/\s+/g, '-');
                // strip special characters and join words with '-'
            }
            else {
                return 'undefined'; // default value brand
            }
        };
        var alternateProductRequest = this.productService.getAlternateProductsDetails($stateParams.productId);
        self.isLoggedIn = function () {
            var loggedInUser = this.Auth.getLoggedInUser();
            if (loggedInUser) {
                return true;
            }
            return false;
        };
        self.accordian = function (item) {
            var obj = this.accordianItem[item];
            if (obj === true) {
                this.accordianItem[item] = false;
            }
            if (obj === false) {
                this.accordianItem[item] = true;
            }
        };
        self.updateInventory = function (item) {
            $scope.totalStock = 0;
            var inventory = {};
            var stocks = [];
            var vendorBackOrder = true;
            var backOrder = true;
            (item.inventory || []).forEach(function (arr) {
                $scope.totalStock += arr.stock;
                stocks.push(arr.stock);
                if (arr.isDefault) {
                    vendorBackOrder = vendorBackOrder && arr.vendorBackOrder;
                    backOrder = backOrder && arr.backOrder;
                    inventory = arr;
                    inventory.stock = arr.stock > 0 ? arr.stock : 0;
                }
            });
            inventory.vendorBackOrder = vendorBackOrder;
            inventory.backOrder = backOrder;
            return inventory;
        };
        self.viewSimilarProducts = function () {
            this.GoogleAnalyticsService.sendEvent('Customer', 'View Similar Products', 'Click View Similar Products on PDP', 1);
            // note: timeout is a hackaround of clicking view similar products from Angualr 10 two times
            $timeout(function () {
                $location.hash('related-products');
                $location.replace();
                $anchorScroll();
            }, 0);
        };
        self.itemDetailLoaded = false;
        self.alternateProductsLoaded = false;
        self.checkIfSimilarProductsCanBeScrolled = function () {
            if (!self.alternateProductsLoaded)
                return;
            if (!self.itemDetailLoaded)
                return;
            if (!$scope.goToSimilarProducts)
                return;
            $scope.goToSimilarProducts = false;
            self.viewSimilarProducts();
        };
        self.onSelectedItemChange = function (selectedItemNum) {
            this.$state.go('productDetail', {
                attributeText: self.products.attributeNamePath,
                productName: self.products.productNamePath,
                productId: self.products.productId,
                itemCode: self.products.items[selectedItemNum].itemCode
            }, { notify: false });
        };
        $scope.$on('$viewContentLoaded', function () {
            self.checkIfSimilarProductsCanBeScrolled();
        });
        $scope.showProduct = false;
        self.loadedData = {
            user: null,
            product: null,
            item: null,
            inventory: null
        };
        self.onUserLoaded = function (user) {
            self.loadedData.user = user;
        };
        self.onProductDetailsLoaded = function (data) {
            var productModel = data.item.productDetails;
            var failed = data.failed;
            var httpStatusCode = data.httpStatusCode;
            $scope.showProduct = true;
            this.previousTitle = this.titleService.getTitle();
            this.previousDescription = this.metaService.getTag('name = "description"').content;
            this.titleService.setTitle(data.item.productDetails.brandName + ' ' + data.item.productDetails.productName + " | Emerson Ecologics");
            var metaDescription = data.item.productDetails.description.replace(/<[^>]*>/g, '');
            this.metaService.updateTag({ name: 'description', content: metaDescription.substring(0, Math.min(155, metaDescription.length)) });
            if (failed) {
                $scope.error = true;
                if (httpStatusCode == 404)
                    this.$state.go('404');
                return;
            }
            self.loadedData.item = data.item;
            self.products = productModel;
            /*Show more less functionality for 400 char*/
            self.productDesc = self.products.description;
            this.changeLimit();
            self.hasBrandAgreement = (self.user !== undefined && self.user !== null) ? self.user.data.response.agreementTypes.indexOf(self.products.brandCode) !== -1 : false;
            /*Show more less functionality for 400 char*/
            this.CommonDataService.addAttributeProductPathsForSingleItem(self.products);
            if (productModel.items.length === 1) {
                self.itemDetail = productModel.items[0];
            }
            else {
                for (var i = 0; i < productModel.items.length; i++) {
                    if (productModel.items[i].itemCode === $stateParams.itemCode) {
                        $scope.selectedItemNum = i;
                        self.itemDetail = productModel.items[i];
                        break;
                    }
                }
            }
            ;
            var isTemporaryHeatSensitiveItem = function () {
                var dateNow = new Date();
                var from_date = Date.parse(new Date(dateNow.getFullYear(), 3, 1)); // the month is 0-based
                var to_date = Date.parse(new Date(dateNow.getFullYear(), 8, 30)); // the month is 0-based
                var today = Date.parse(dateNow);
                if (today > from_date && today < to_date) {
                    return true;
                }
                else {
                    return false;
                }
            };
            var isPDVAvailable = function (ingredients) {
                var pdv = false;
                if (!!ingredients) {
                    ingredients.forEach(function (ingredient) {
                        if (ingredient.percentageDailyValue) {
                            pdv = true;
                        }
                    });
                }
                return pdv;
            };
            $scope.isTempHeatSensitiveItem = isTemporaryHeatSensitiveItem();
            $scope.pdv = isPDVAvailable(self.products.ingredients);
            $scope.otherIngredients = self.getOtherIngredients(self.products.ingredients);
            $scope.labelText = $sce.trustAsHtml(self.products.labelText);
            $scope.suggestedUse = $sce.trustAsHtml(self.products.suggestedUse);
            $scope.causion = $sce.trustAsHtml(self.products.warnings);
            self.inventories = self.updateInventory(self.itemDetail);
            if ((self.itemDetail.isDiscontinued || self.inventories.vendorBackOrder) && self.inventories.stock > 0) {
                self.maxQty = self.inventories.stock;
            }
            ;
            var currentDate = new Date();
            var expectedDate = new Date(self.inventories.expectedDeliverDate);
            if (expectedDate > currentDate) {
                this.showBackInStockDate = true;
            }
            ;
            self.itemDetailLoaded = true;
            self.checkIfSimilarProductsCanBeScrolled();
        };
        var alternateProducts = {};
        alternateProductRequest
            .then(function (response) {
            if (!!response && !!response[0]) {
                self.alternateProducts = response.filter(function (product) { return product.items.some(function (item) { return !item.isRestricted &&
                    item.inventory.some(function (i) { return i.stock > 0 && i.isDefault; }); }); });
                if (self.alternateProducts) {
                    for (var i = 0; i < self.alternateProducts.length; i++) {
                        self.AllAlternateIds.push(self.alternateProducts[i].productId);
                        if (i < self.carouselcapacity)
                            self.CarouselIds.push(self.alternateProducts[i].productId);
                    }
                }
                self.alternateProductsLoaded = true;
                self.checkIfSimilarProductsCanBeScrolled();
            }
        });
        self.ClickSwipe = function (dir) {
            if (dir === 'right') {
                if (self.AllAlternateIds.length <= self.carouselcapacity) {
                }
                else if (self.CarouselIds[self.carouselcapacity - 1] === self.AllAlternateIds[self.AllAlternateIds.length - 1]) {
                }
                else {
                    self.CarouselIds.shift();
                    var newid = self.AllAlternateIds[self.AllAlternateIds.indexOf(self.CarouselIds[self.CarouselIds.length - 1]) + 1];
                    self.CarouselIds.push(newid);
                }
            }
            else if (dir === 'left') {
                if (self.AllAlternateIds.length <= self.carouselcapacity) {
                }
                else if (self.CarouselIds[0] === self.AllAlternateIds[0]) {
                }
                else {
                    self.CarouselIds.pop();
                    var newid = self.AllAlternateIds[self.AllAlternateIds.indexOf(self.CarouselIds[0]) - 1];
                    self.CarouselIds.unshift(newid);
                }
            }
        };
        self.disableShoppingCart = function () {
            if (self.inventories.vendorBackOrder && self.inventories.stock <= 0) {
                return true;
            }
            else if (self.itemDetail.isDiscontinued && self.inventories.stock <= 0) {
                return true;
            }
            else {
                return self.itemDetail.isRestricted;
            }
        },
            self.disableCartBtn = function () {
                if (!self.purchaseNumber) {
                    return true;
                }
                else if (self.inventories.vendorBackOrder && self.inventories.stock <= 0) {
                    return true;
                }
                else if (self.itemDetail.isDiscontinued && self.inventories.stock <= 0) {
                    return true;
                }
            },
            $scope.$watch('selectedItemNum', function (num) {
                if (self.products.hasOwnProperty('items')) {
                    self.itemDetail = self.products.items[num];
                }
                self.selectedImg = 'front';
                if (self.itemDetail.hasOwnProperty('inventory')) {
                    $scope.totalStock = 0;
                    self.inventories = self.updateInventory(self.itemDetail);
                }
            });
        $scope.logIn = function () {
            $window.location = '/auth/ares';
        };
        $scope.signUp = function () {
            $window.location = '/registration';
        };
        UserService.get().then(function (user) {
            if (user.data.response) {
                console.log("Account API", user.data.response);
                self.loggedInAs = user.data.response.accountType;
                self.isdoctorType = (user.data.response.doctorTypes.length > 0);
                self.user = user;
            }
        })
            .catch(function (err) {
            console.log("productDetailControllerJS UserService Error => " + err);
        });
        /*quantity dropdown*/
        $scope.currentIndex = null;
        $scope.closeThis = closeThis;
        $scope.back_search = back_search;
        $scope.setCurrentItem = setCurrentItem;
        function closeThis() {
            $scope.currentIndex = null;
        }
        function back_search() {
            $window.history.back();
        }
        function setCurrentItem(itemId) {
            if (itemId == $scope.currentIndex) {
                $scope.currentIndex = null;
            }
            else {
                $scope.currentIndex = itemId;
            }
        }
        self.renderThumbnailImage = function (url) {
            this.itemDetail.frontImageUrl = url;
        };
        self.itemKey = {
            productId: $stateParams.productId,
            itemCode: $stateParams.itemCode
        };
        self.getEqpStatus = function () {
            if (self.products == null || self.products.eqpLevel != 50 && self.products.eqpLevel != 40)
                return 'None';
            return self.products.eqpLevel == 50 ? 'Gold' : 'Silver';
        };
        self.onItemSelected = function (data) {
            // note: this is the brand new callback
            this.$state.go('productDetail', {
                attributeText: CommonDataService.toPathStyle(data.item.productDetails.attributeName),
                productName: CommonDataService.toPathStyle(data.item.productDetails.productName || data.item.productDetails.displayName),
                productId: data.item.productDetails.productId,
                itemCode: data.item.itemCode
            }, { notify: true });
        };
        /*end quantity dropdown*/
    }
    ProductDetailController.prototype.isItemOutOfStock = function () {
        return this.inventories != null &&
            this.itemDetail != null &&
            this.inventories.backOrder &&
            !this.inventories.vendorBackOrder &&
            !this.itemDetail.isRestricted;
    };
    ProductDetailController.prototype.isItemOutOfStockWithVBO = function () {
        return this.inventories.vendorBackOrder &&
            this.itemDetail != null &&
            !this.itemDetail.isRestricted &&
            this.inventories.stock <= 0;
    };
    ProductDetailController.prototype.isItemWithNoStockInfo = function () {
        return this.itemDetail == null ||
            this.itemDetail.inventory == null ||
            this.itemDetail.inventory.length === 0;
    };
    ProductDetailController.prototype.shouldShowBackInStockSubscription = function () {
        return this.isItemOutOfStock() || this.isItemOutOfStockWithVBO() || this.isItemWithNoStockInfo();
    };
    ProductDetailController.prototype.getOutOfStockMessage = function () {
        if (!this.shouldShowBackInStockSubscription())
            return '';
        if (this.isItemOutOfStockWithVBO() && !this.isItemWithNoStockInfo()) {
            return 'This item is on backorder with our brand partner.';
        }
        var expectedDeliverDate = (this.inventories || {}).expectedDeliverDate;
        var showBackInStockDate = this.showBackInStockDate;
        if (expectedDeliverDate && showBackInStockDate)
            return "Item Out of Stock. Back in stock on " + this.$filter('date')(expectedDeliverDate, 'MM/dd/yyyy') + ".";
        return 'This item is currently out of stock. It will ship on the earliest possible date.';
    };
    ProductDetailController.prototype.isQuantityValid = function (form, currentItem) {
        var self = this;
        var currentProd = currentItem.itemCode;
        var currentProdQty = parseInt(form[currentProd].$viewValue);
        if (isNaN(currentProdQty)) {
            this.purchaseNumber = this.oldPurchaseQuantity;
        }
        else {
            this.oldPurchaseQuantity = currentProdQty;
            var defaultInventory = this.cart.getDefaultInventory(currentItem.inventory);
            var onHandQuantity = defaultInventory.stock;
            if ((defaultInventory && defaultInventory.vendorBackOrder) && this.purchaseNumber > onHandQuantity) {
                this.purchaseNumber = onHandQuantity;
            }
        }
        if (currentItem.mandatorySalesMultiple != 0) {
            if (currentProdQty % currentItem.mandatorySalesMultiple !== 0) {
                self.multipleOf = true;
                document.getElementsByName(currentProd).forEach(function (item) {
                    if (item != undefined) {
                        var calcQty = Math.ceil(currentProdQty / currentItem.mandatorySalesMultiple) * currentItem.mandatorySalesMultiple;
                        item.value = calcQty;
                        form[currentProd].$viewValue = calcQty;
                    }
                });
            }
            else {
                self.multipleOf = false;
            }
        }
    };
    return ProductDetailController;
}());
export default ProductDetailController;
//# sourceMappingURL=product-detail.controller.js.map